import React, { useEffect, useState } from "react";
import LoadingState from "Admin/components/LoadingState";
import { GenGet } from "state/api";
import MsgAlert from "Admin/components/MsgAlert";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import CustomSelect from "Admin/components/AdminComponents/CustomSelect";
import CreateAgendamento from "./CreateAgendamento";
import CreateClientes from "../Clientes/CreateClientes"; // Adicione este import

// Configuração do moment para português
import 'moment/locale/pt-br';
import EditarAgendamento from "./EditarAgendamento";
moment.locale('pt-BR');
const localizer = momentLocalizer(moment);

function Agendamentos() {
  const [msg, setMsg] = useState(null);
  const [data, setData] = useState([]);
  const [profissionalLoockup, setProfissionalLookup] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [selectedProfissional, setSelectedProfissional] = useState(1);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(moment().format('YYYY-MM-DD'));
  const [clienteModalOpen, setClienteModalOpen] = useState(false); // Novo estado

  const handleLookupChange = (e) => {
    setSelectedProfissional(e.target.value);
  };

  const handleCloseModal = () => {  
    setModalOpen(false);
    setCreateModalOpen(false);
    setDatePickerOpen(false);
    setRefresh(true);
  }

  const fetchData = async (endpoint, setter) => {
    try {
      const response = await GenGet(endpoint);
      setter(response);
    } catch (err) {
      setMsg("Erro ao buscar agendamentos");    
      setTimeout(() => setMsg(null), 3000);
    }
  }; 

  useEffect(() => {
    Promise.all([
      fetchData('/agendamentos', setData),
      fetchData('/profissionais/lookup', setProfissionalLookup),
    ]).then(() => setLoading(false)); 
  }, []);

  useEffect(() => {
    if (refresh) {
    
      Promise.all([
        fetchData('/agendamentos', setData),
        fetchData('/profissionais/lookup', setProfissionalLookup),
      ]).then(() => setLoading(false), setRefresh(false)); 
    }
  }, [refresh]);

  useEffect(() => {
    // Remove o UTC e trabalha com data local
    const adjustedDate = moment(selectedDateTime).startOf('day').toDate();
    setSelectedDate(adjustedDate);
  }, [selectedDateTime]);

  const formatEvents = () => {
    return data
      .filter(item => item.profissional_id === selectedProfissional)
      .map(item => ({
        id: item.id,
        title: `Cliente: ${item.cliente ? item.cliente.nome : 'Não identificado'} - ${item.servico_produto.nome}`,
        start: new Date(item.data_hora), // Mantém como data local
        end: moment(item.data_hora).add(item.duracao, 'minutes').toDate(), // Mantém como data local
        status: item.status,
        profissional: item.profissional_id
      }));
  };

  const CustomToolbar = ({ date, onNavigate }) => (
    <div className="flex items-center justify-between p-2 mb-4 bg-white rounded flex-wrap gap-2">
      <div className="flex gap-2 flex-wrap">
        <Button variant="outlined" onClick={() => onNavigate('TODAY')}>Hoje</Button>
        <Button variant="outlined" onClick={() => onNavigate('PREV')}>Anterior</Button>
        <Button variant="outlined" onClick={() => onNavigate('NEXT')}>Próximo</Button>
        <Button variant="outlined" onClick={() => setDatePickerOpen(true)}>Escolher Data</Button>
        <Button variant="outlined" onClick={() => setCreateModalOpen(true)}>Novo Agendamento</Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => setClienteModalOpen(true)}
        >
          Novo Cliente
        </Button>
      </div>
      
      <div className="text-lg font-semibold">
        {moment(date).format('DD/MM/YYYY')}
      </div>
      
      {profissionalLoockup && (
        <div className="min-w-[200px]">
          <CustomSelect
            name={'profissional_id'}
            label={'Profissional'}
            data={profissionalLoockup}
            value={selectedProfissional}
            onChange={handleLookupChange}
            search={false}
          />
        </div>
      )}
    </div>
  );

  if (loading) {
    return <LoadingState />;
  }

  return (
    <div className='flex flex-col h-[85vh] bg-slate-100 rounded-md shadow-md p-4 overflow-hidden '>
      <MsgAlert alert={msg} />
      
      <div className='bg-white p-2 rounded-md overflow-y-scroll no-scrollbar'>
        <Calendar
          className="no-scrollbar"
          localizer={localizer}
          events={formatEvents()}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 600 }}
          components={{
            toolbar: CustomToolbar
          }}
          view="day" // Apenas a visualização de dia
          date={selectedDate}
          onNavigate={(date)=>{
            setSelectedDate(date);
            setSelectedDateTime(moment(date).format('YYYY-MM-DD'));
          }}
          step={15}
          timeslots={4}
          min={new Date(2025, 0, 1, 8, 0, 0)} // 8:00 AM
          max={new Date(2025, 0, 1, 19, 0, 0)} // 6:00 PM
          selectable
          onSelectEvent={event => {
            setSelectedEvent(event);
            setModalOpen(true);
          }}
          onSelectSlot={slotInfo => {
            setSelectedSlot({
              start: slotInfo.start,
              end: slotInfo.end,
              profissional_id: selectedProfissional
            });
            setCreateModalOpen(true);
          }}
          messages={{
            today: 'Hoje',
            previous: 'Anterior',
            next: 'Próximo',
            date: 'Data',
            time: 'Hora',
            event: 'Evento',
            noEventsInRange: 'Nenhum agendamento neste período.'
          }}
        />
      </div>

      {/* Modal de Detalhes do Evento */}
      <Dialog 
        open={modalOpen} 
        onClose={() => handleCloseModal()} 
        PaperProps={{
          style: {
            width: '70vw',
            maxWidth: 'none',
          }
        }}>
        <DialogContent>
          {selectedEvent && (
            <EditarAgendamento event={selectedEvent} />
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Novo Agendamento */}
      <Dialog 
        open={createModalOpen} 
        onClose={() => handleCloseModal()} 
        PaperProps={{
          style: {
            width: '80vw',
            height: '80vh',
            maxWidth: 'none', 
            maxHeight: 'none',
          }
        }}>
        <DialogContent>
          {createModalOpen && (
            <CreateAgendamento
              onSuccess={() => {
                setCreateModalOpen(false);
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Novo Cliente */}
      <Dialog 
        open={clienteModalOpen} 
        onClose={() => setClienteModalOpen(false)}
        PaperProps={{
          style: {
            width: '80vw',
            maxWidth: 'none',
          }
        }}>
        <DialogTitle>Novo Cliente</DialogTitle>
        <DialogContent>
          <CreateClientes />
        </DialogContent>
      </Dialog>

      {/* Modal de seleção de data */}
      <Dialog open={datePickerOpen} onClose={() => handleCloseModal()}>
        <DialogTitle>Escolha uma data</DialogTitle>
        <DialogContent>
          <TextField
            type="date"
            value={selectedDateTime}
            onChange={(e) => {
              setSelectedDateTime(e.target.value);
              setSelectedDate(moment(e.target.value).toDate());
            }}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </DialogContent>

      </Dialog>
    </div>
  );
}

export default Agendamentos;